import { PublicLayout } from "../PublicLayout";

export function PublicLargeLayout({ children }) {
  return <PublicLayout maxWidth="min(100%, 1700px)">{children}</PublicLayout>;
}
